import jQuery from 'jquery';
import jQueryI18next from 'jquery-i18next';
import i18n from 'i18next';

// TODO: Remove the localize and data-i18n attributes to get rid of this plugin
jQueryI18next.init(i18n, jQuery, {
    tName: 't',
    i18nName: 'i18n',
    handleName: 'localize',
    selectorAttr: 'data-i18n',
    targetAttr: 'i18n-target',
    optionsAttr: 'i18n-options',
    useOptionsAttr: false,
    parseDefaultValueFromContent: true,
});
